<template>
  <div>
    <div class="card-wrapper">
      <div @click="turn" :class="['card', {'uk-card-primary': '!isUp', 'uk-card-secondary': isUp, 'off-the-field': !inTheField, playable: inTheField, acquired: !inGame, 'uk-card-hover': canTurnUp}]">
        {{ visibleText }}
      </div>
      <a href="#modal-example" uk-toggle="target: #modal-example">
        <span v-if="inGame && licenseLink" :class="['license', 'uk-label', {'uk-background-secondary': isUp}]">cc</span>
      </a>
      <span v-if="!inTheField" class="uk-text-small subtitle">{{ text }}</span>
    </div>
    <div id="modal-example" uk-modal>
      <div class="uk-modal-dialog uk-modal-body">
        <h2 class="uk-modal-title">{{ $t( "cards.licence.header" )}}</h2>
        <p>{{ $t("cards.licence.detail")}}</p>
        <a :href="licenseLink" target=_blank> {{ $t("cards.licence.link")}}</a>
        <p class="uk-text-right">
          <button class="uk-button uk-button-default uk-modal-close" type="button">{{ $t("buttons.close")}}</button>
        </p>
      </div>
    </div>
  </div>

</template>

<script>
  import { mapGetters } from "vuex"
  export default {
    props: ["card", "inTheField"],
    data() {
      return {
        inGameIcon: "🐦",
        acquiredIcon: "✔️"
      }
    },
    computed: {
      isUp() {
        return this.card.turnedUp;
      },
      visibleText() {
        if (this.inGame) return this.inGameIcon
        return this.acquiredIcion
      },
      text() {
        return this.card.text;
      },
      canTurnUp() {
        return (this.isUp === false) && this.facingUpCount < 2;
      },
      inGame() {
        return this.card.owner === null;
      },
      canPlaySound() {
        return (this.canTurnUp) || (!this.inTheField && !this.card.sound.playing())
      },
      licenseLink() {
        return this.card.license;
      },
      acquiredIcion() {
        return this.inTheField ? this.card.owner.emoji.symbol : this.acquiredIcon
      },
      debugMode() {
        return this.$route.query.dev === "1"
      },
      ...mapGetters(["facingUpCount"])
    },
    methods: {
      turn: function() {
        this.$emit("turnedUp");
        if (this.canPlaySound) {
          this.card.sound.play();
        } else {
          this.card.sound.stop();
        }
        if (this.canTurnUp) {
          if (this.debugMode) { console.log(this.card.text) }
          this.$store.dispatch("turnUp", { card: this.card });
        }
      }
    }
  }
</script>

<style scoped>
  .card {
    padding: 45px;
    margin: 1em;
  }
  .card.off-the-field {
    padding: 18px;
  }
  .acquired {
    opacity: 0.5;
  }
  .off-the-field.acquired {
    opacity: 1;
  }
  .license {
    position: relative;
    top: -40px;
    left: 35px;
  }
  .uk-text-small {
    display: block;
    width: 90px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Card.vue